import React, {useEffect, useState} from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import routes from "../../../routes/ecommerce.routes";
import { Container } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import Main from "../../../components/Main/index";
import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Table from "../../../components/Table";
import Animation from "../../../components/Animation/animation";
import ModalProductDetail from "../../../components/ModalProduct";
import {
    Row,
    THead, 
    Th, 
} from "./styles";
import { openModal } from "../../../helpers/modalFunctions";
import { IProduct } from "./interfaces";
import ModalCreatedProduct from "../../../components/ModalCreateProduct";
import FormEditProduct from "../../../components/FormEditProduct";
import FormEditDetails from "../../../components/GroupFormEditDetails";
import FormAddDetails from "../../../components/FormAddDetails";
import FormAddImage from "../../../components/FormAddImage";
import { useQuery } from "react-query";
import { getProducts } from "../../../hooks/getProducts";
import { useFormProduct } from "../../../hooks/useFormProduct";
import TableContentListProducts from "../../../components/TableContentListProducts";

const Products = (): React.ReactElement => {
    const login = useSelector((state: {login: any}) => state.login);
    const history = useHistory();
    const [ product, setProduct ] = useState<Array<IProduct>>([])
    const [page, setPage] = useState<number>(1);
    const [maxPage, setMaxPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedProduct, setSelectedProduct] = useState<IProduct>({
        id: "",
        nameProduct: "",
        active: true,
        amount: "",
        updated_at: "",
        created_at: "",
        description: "",
        details: "",
    })
    const [refresh, setRefresh] = useState<boolean>(false);

    const { ...useForm } = useFormProduct()
    
    useEffect(() => {
        if(login.user.groups.cm7a1 === false){
            history.push("/admin/dashboard");
        }
    }, []);

    useQuery(["getProducts", refresh], async () => {
        if(product.length === 0 || refresh) {
            const { loading } = await getProducts(
                login,
                setProduct,
                setPage,
                setMaxPage
            );

            setIsLoading(loading)
        }
    })

    const openForm =  useForm.isAddDetailsVisible || useForm.isAddImageVisible || useForm.isEditDetailsVisible || useForm.isEditFormVisible;
    
    return (
        <Container fluid >
            <ToastContainer autoClose={2000}/>
            <Row>
                <ModalProductDetail title="Informações do produto" type="product" product={selectedProduct!}/>
                <ModalCreatedProduct/>
                <Main className={` ${openForm ? "col-d-none column-side-open" : "column-content"}`}>
                    <Header title="Lista de produtos" subTitle="Visualize e edite informações dos seus produtos." subTitleWidth={200}/>
                    <NavTabs tabs={routes}/>
                    <Table
                        id="addProduct"
                        buttonText="Adicionar produto"
                        showAddButton={true}
                        setIsAddFormVisible={() => openModal("addProduct")}
                        page={page}
                        maximumPage={maxPage}
                        setPage={setPage}
                        nonFilterable
                    >
                        <THead>
                            <tr>
                                <Th>ID</Th>
                                <Th>Nome</Th>
                                <Th>Valor</Th>
                                <Th>Status</Th>
                                <Th>Criação</Th>
                                <Th>Última edição</Th>
                                <Th></Th>
                            </tr>
                        </THead>
                        {
                            isLoading 
                            ? <Animation/>
                            : <tbody>
                                <TableContentListProducts
                                    listProducts={product}
                                    setSelectedProduct={setSelectedProduct}
                                    useForm={useForm}
                                />
                            </tbody>
                        }
                    </Table>
                </Main>
                {
                    useForm.isEditFormVisible 
                        && <FormEditProduct
                            isVisible={useForm.isEditFormVisible }
                            selectedProduct={selectedProduct}
                            formState={useForm.handlerFormEdit}
                            setRefresh={setRefresh}
                        />
                }

                { 
                    useForm.isEditDetailsVisible
                        && <FormEditDetails
                            isVisible={useForm.isEditDetailsVisible}
                            formState={useForm.handlerFormEditDetail}
                            selectedProduct={selectedProduct}
                            setRefresh={setRefresh}
                        /> 
                }
                
                {
                    useForm.isAddDetailsVisible
                        && <FormAddDetails
                            isVisible={useForm.isAddDetailsVisible}
                            formState={useForm.handlerFormAddDetail}
                            selectedProduct={selectedProduct}
                            setRefresh={setRefresh}
                        /> 
                }

                {
                    useForm.isAddImageVisible
                        && <FormAddImage
                            isVisible={useForm.isAddImageVisible}
                            formState={useForm.handlerFormAddImage}
                            selectedProduct={selectedProduct}
                            setRefresh={setRefresh}
                        /> 
                }   
            </Row>
        </Container>
    )
}

export default Products;